import { render, staticRenderFns } from "./CTABox.vue?vue&type=template&id=4e9c862f&scoped=true&"
import script from "./CTABox.vue?vue&type=script&lang=js&"
export * from "./CTABox.vue?vue&type=script&lang=js&"
import style0 from "./CTABox.vue?vue&type=style&index=0&id=4e9c862f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c862f",
  null
  
)

export default component.exports